// extracted by mini-css-extract-plugin
export default {"button":"ButtonLink_button__LEa4i","disabled":"ButtonLink_disabled__g4Twj"};